import React from 'react';
import './ScoreIndicator.css';

interface ScoreIndicatorProps {
  percentPositive: number;
  averageScore?: number;
  size?: 'small' | 'medium' | 'large';
  showBoth?: boolean;
}

export function getHealthColor(percentPositive: number): string {
  if (percentPositive >= 75) return '#34c759'; // green
  if (percentPositive >= 50) return '#ff9500'; // yellow/orange
  return '#ff3b30'; // red
}

export function getHealthLabel(percentPositive: number): string {
  if (percentPositive >= 75) return 'Good';
  if (percentPositive >= 50) return 'Needs Attention';
  return 'Concern';
}

const ScoreIndicator: React.FC<ScoreIndicatorProps> = ({
  percentPositive,
  averageScore,
  size = 'medium',
  showBoth = true,
}) => {
  const color = getHealthColor(percentPositive);

  return (
    <div className={`score-indicator score-indicator--${size}`}>
      <div className="score-indicator__primary" style={{ color }}>
        <span className="score-indicator__value">{Math.round(percentPositive)}%</span>
        <span className="score-indicator__label">Positive</span>
      </div>
      {showBoth && averageScore !== undefined && (
        <div className="score-indicator__secondary">
          <span className="score-indicator__value">{averageScore.toFixed(1)}</span>
          <span className="score-indicator__label">Avg Score</span>
        </div>
      )}
      <div
        className="score-indicator__badge"
        style={{ backgroundColor: color }}
      >
        {getHealthLabel(percentPositive)}
      </div>
    </div>
  );
};

export default ScoreIndicator;
